var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("h6", [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: `/#/portfolio-plan/projects/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.scenarioId}`,
                            expression:
                              "`/#/portfolio-plan/projects/${workspaceId}/${tchProjectId}/${scenarioId}`",
                          },
                        ],
                        staticClass: "text-dark",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-double-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Back to plan\n                    "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v(_vm._s(_vm.rm.ScenarioName))]
                  ),
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "col-lg-6 text-right align-self-end",
                }),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "mb-5" }),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "navbar navbar-light navbar-expand-md bg-light",
                  attrs: { role: "navigation" },
                },
                [
                  _c("form", { staticClass: "form-inline my-2 my-lg-0" }, [
                    _c("div", { staticClass: "dropdown" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-secondary btn-sm dropdown-toggle",
                          attrs: { type: "button", "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.criteriaFilter) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                _vm.criteriaFilter = "Objectives"
                              },
                            },
                          },
                          [_vm._v("Objectives (top)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                _vm.criteriaFilter = "Attributes"
                              },
                            },
                          },
                          [_vm._v("Attributes (bottom)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                _vm.criteriaFilter = "All criteria"
                              },
                            },
                          },
                          [_vm._v("All criteria")]
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", [
                _c("h4", { staticClass: "mt-5" }, [
                  _vm._v("1. Criteria weights"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive mt-3" }, [
                  _c("table", { staticClass: "table table-bordered" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.criteria, function (c) {
                        return _c("tr", { key: c.Id }, [
                          _c("td", [
                            !c.IsTop
                              ? _c("span", [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v("..." + _vm._s(c.Path)),
                                  ]),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n                                " +
                                _vm._s(c.Name) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(c.LocalWeight))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(c.GlobalWeight))]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "mt-5" }, [
                  _vm._v("2. Criteria weights vs. Portfolio value share"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive mt-3" }, [
                  _c("table", { staticClass: "table table-bordered" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.criteria, function (c) {
                        return _c("tr", { key: c.Id }, [
                          _c("td", [
                            !c.IsTop
                              ? _c("span", [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v("..." + _vm._s(c.Path)),
                                  ]),
                                  _c("br"),
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n                                " +
                                _vm._s(c.Name) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(c.GlobalWeight))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(c.GlobalValueShare))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(c.Diff))]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "mt-5" }, [
                  _vm._v("3. Project Value Stats"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive mt-3" }, [
                  _c("table", { staticClass: "table table-bordered" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _c("tr", { staticClass: "table-secondary" }, [
                          _c("td", [_vm._v(_vm._s(_vm.goal.Name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.goal.AvgValue))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.goal.MinValue))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.goal.MaxValue))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.goal.StdDev))]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.criteria, function (c) {
                          return _c("tr", { key: c.Id }, [
                            _c("td", [
                              !c.IsTop
                                ? _c("span", [
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v("..." + _vm._s(c.Path)),
                                    ]),
                                    _c("br"),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(c.Name) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.AvgValue))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.MinValue))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.MaxValue))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.StdDev))]),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "mt-5" }, [
                  _vm._v("4. No. of Projects by Value"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive mt-3" }, [
                  _c("table", { staticClass: "table table-bordered" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _c("tr", { staticClass: "table-secondary" }, [
                          _c("td", [_vm._v(_vm._s(_vm.goal.Name))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.goal.ScoresCount0))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.goal.ScoresCount1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.goal.ScoresCount2))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.goal.ScoresCount3))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.goal.ScoresCount4))]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.criteria, function (c) {
                          return _c("tr", { key: c.Id }, [
                            _c("td", [
                              !c.IsTop
                                ? _c("span", [
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v("..." + _vm._s(c.Path)),
                                    ]),
                                    _c("br"),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(c.Name) +
                                  "\n                            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.ScoresCount0))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.ScoresCount1))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.ScoresCount2))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.ScoresCount3))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.ScoresCount4))]),
                          ])
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Criteria")]),
        _vm._v(" "),
        _c("th", [_vm._v("Local Weight [%]")]),
        _vm._v(" "),
        _c("th", [_vm._v("Global Weight [%]")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Criteria")]),
        _vm._v(" "),
        _c("th", [_vm._v("Weight [%]")]),
        _vm._v(" "),
        _c("th", [_vm._v("Value Share [%]")]),
        _vm._v(" "),
        _c("th", [_vm._v("Diff [%]")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Criteria")]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "4" } }, [_vm._v("Project Value Stats")]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v("Avg value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Min value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Max value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Std dev")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { rowspan: "2" } }, [_vm._v("Criteria")]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "5" } }, [
          _vm._v("No. of Projects by Value"),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v("0")]),
        _vm._v(" "),
        _c("th", [_vm._v("0-25")]),
        _vm._v(" "),
        _c("th", [_vm._v("25-50")]),
        _vm._v(" "),
        _c("th", [_vm._v("50-75")]),
        _vm._v(" "),
        _c("th", [_vm._v("75-100")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }